const normalizeSaleItemLabel = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const AUXILIARY_SALE_ITEM_LABELS = new Set([
  "costo de envio",
  "costo envio",
  "envio",
  "delivery",
  "shipping",
  "shipping cost",
]);

export const isAuxiliarySaleItem = (item) => {
  if (!item) return false;
  if (item.product_id) return false;

  const normalizedName = normalizeSaleItemLabel(
    item.product_name_snapshot || item.products?.name || "",
  );

  if (!normalizedName) return false;
  if (AUXILIARY_SALE_ITEM_LABELS.has(normalizedName)) return true;

  return normalizedName.startsWith("costo de envio");
};

export const isDeliverableSaleItem = (item) =>
  Number(item?.quantity || 0) > 0 && !isAuxiliarySaleItem(item);

export const isOperationalInventorySaleItem = (item) =>
  Boolean(item?.product_id) && isDeliverableSaleItem(item);
